module.exports = __webpack_public_path__ + "img/running.bb65e51a.svg";